import cn from 'classnames';
import {useFormikContext} from 'formik';
import {ChangeEvent, useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {BottomSheet} from 'react-spring-bottom-sheet';

import AdvertismentMap from '../../../../../../components/advertisementMap';
import FormikLikeInput from '../../../../../../components/formikFileds/likeInput';
import FormikTextArea from '../../../../../../components/formikFileds/textArea';
import {useAuth} from '../../../../../../context/authContext';
import FloatingOnlySelectBottomSheet from '../../../../../../module/newShop/advertisementRegisteration/floatingOnlySelectBottomSheet';
import useGetCultivations from '../../../../../../services/hookService/getCultivations/useGetCultivations';
import {RootState} from '../../../../../../store/redux';
import {
  addFormData,
  addRegisterAdvertisement,
  isSendingData,
} from '../../../../../../store/redux/advertisementRegisteration';
import {ScrollSection} from '../../../../../../utilities/helper/scrollToError/errorScroll.constants';
import {FromikType} from '../../../types';
import {serviceHandleDescriptionText} from '../../../utils';

const WantedServiceMachineryForm = ({
  isLoading,
  setModalText,
}: {
  isLoading?: boolean;
  setModalText?: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const {supplierProfile} = useAuth();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const myRef = useRef<HTMLDivElement | null>(null);

  // const [images, setImages] = useState<IUploadImage[]>([]);
  const [touched, setTouched] = useState<boolean>(false);
  const [openCultivationBottomSheet, setOpenCultivationBottomSheet] =
    useState<boolean>(false);
  const [location, setLocation] = useState<ILocation>({
    lat: Number(supplierProfile?.latlong?.[0]),
    lng: Number(supplierProfile?.latlong?.[1]),
  });
  const [areaText, setAreaText] = useState<string>('');

  const {input, sub_input, input_group} = useSelector(
    (state: RootState) => state.advertisementRegisteration,
  );
  const {setFieldValue, values, errors} = useFormikContext<FromikType>();

  const {cultivationList} = useGetCultivations();

  useEffect(() => {
    if (input_group && sub_input && input_group.type && values?.wanted_number) {
      setFieldValue(
        'title',
        serviceHandleDescriptionText(
          values,
          sub_input?.title,
          values?.wanted_number,
        )[input_group.type],
      );
      setAreaText(
        serviceHandleDescriptionText(
          values,
          sub_input?.title,
          values?.wanted_number,
        )[input_group.type],
      );
    }
  }, [values.cultivation?.title, input_group]);

  useEffect(() => {
    setFieldValue('location', location);
  }, [location]);

  useEffect(() => {
    myRef.current?.scrollIntoView({behavior: 'smooth'});
  }, [myRef.current]);

  return (
    <div>
      <section className="flex flex-col" id={ScrollSection.SUB_INPUT}>
        <div className="flex mb-2 text-gray-900 font-Medium" ref={myRef}>
          {/* <span className="text-md">
            نوع {input_group?.type && GroupNameToInputName[input_group?.type]}{' '}
            {input?.title} را وارد کنید.
          </span> */}
          <span className="text-md">نوع {input?.title} را وارد کنید.</span>
          <span className="color-red-3">*</span>
        </div>
        <div
          className={cn(
            'w-full h-12 rounded border-[1px] border-gray-700 px-2 flex items-center',
            {
              '!border-red-550': touched && errors.sub_input?.title,
              '!border-farm-shop-500':
                values.sub_input?.title && !errors.sub_input?.title,
            },
          )}
        >
          {!sub_input?.title && (
            <i className="mx-1 text-xl text-gray-700 icon-nameSearch" />
          )}
          <input
            className="w-full text-md text-gray-950 placeholder:text-gray-700"
            name="sub_input"
            readOnly={true}
            value={sub_input?.title}
            placeholder="انتخاب نوع"
            onClick={() => {
              navigate('/advertisement-register-subInput-list', {
                state: {
                  input: input?.guid,
                  backRoute: '/advertisement-registeration',
                },
              });
            }}
          ></input>
        </div>
        <span className="pt-1 text-xs text-red-550">
          {touched && errors.sub_input?.title}
        </span>
      </section>
      <section className="flex flex-col mt-3" id={ScrollSection.CULTIVATION}>
        <div className="flex mb-3 text-md">
          <span> کشت خود را جهت دریافت خدمات انتخاب کنید.</span>
          <span className="color-red-3 ">*</span>
        </div>
        <FloatingOnlySelectBottomSheet
          Placeholder="انتخاب کشت"
          name="cultivation"
          wrapperClass="border-gray-700"
          onClick={() => setOpenCultivationBottomSheet(true)}
          value={values?.cultivation?.title}
          //@ts-ignore
          errors={touched && (errors.cultivation?.title as string)}
        />
        <BottomSheet
          onDismiss={() => setOpenCultivationBottomSheet(false)}
          open={openCultivationBottomSheet}
          blocking={true}
          snapPoints={({minHeight, maxHeight}) => [minHeight, maxHeight / 0.6]}
        >
          <div className="flex flex-col gap-2 p-4">
            {cultivationList?.map(item => (
              <div
                key={item.guid}
                onClick={() => {
                  setFieldValue('cultivation', {
                    title: item.mahsul.title,
                    guid: item.guid,
                  });
                  setFieldValue('wanted_number', item.area);
                  setOpenCultivationBottomSheet(false);
                }}
              >
                {item?.mahsul?.title}-{item.farm_name}
              </div>
            ))}
          </div>
        </BottomSheet>
      </section>
      <section className="my-3" id={ScrollSection.INPUT_UNIT}>
        <FormikLikeInput
          name="wanted_number"
          label="مساحت مزرعه (هکتار)"
          disabled={true}
          required={false}
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            setFieldValue('wanted_number', e.target.value);
          }}
        />
      </section>
      <section className="mt-3" id={ScrollSection.TITLE}>
        <FormikTextArea
          name="title"
          placeholder=""
          label="متن درخواست"
          touched={
            (values.title && !errors.title) || (!values.title && errors.title)
              ? true
              : touched
          }
          required
          rows={5}
          labelClass="!text-md font-medium"
        />
        <span className="text-xs text-gray-900">
          میتوانید متن درخواست خود را ویرایش کنید.
        </span>
      </section>
      <section className="flex flex-col mt-3" id={ScrollSection.LOCATION}>
        <span className="mb-3 text-md">محدوده آگهی</span>
        <div className="z-0 mb-3 edit-ads-map">
          <AdvertismentMap
            center={location}
            selectLocation={location => {
              setFieldValue('location', location);
              setLocation(location);
            }}
          />
        </div>
      </section>
      <button
        className={cn('w-full text-white h-12 rounded mb-3', {
          'bg-farm-shop-200': isLoading,
          'bg-farm-shop-500': !isLoading,
        })}
        disabled={isLoading}
        type="submit"
        onClick={() => {
          dispatch(
            addRegisterAdvertisement({
              is_change_title: areaText === values?.title,
            }),
          );
          setModalText && setModalText('');
          if (areaText === values?.title) {
            setModalText &&
              setModalText('آگهی شما با موفقیت در فروشگاه مزرعه منتشر شد.');
          }

          dispatch(addFormData(JSON.stringify(values)));
          dispatch(isSendingData(true));
          setTouched(true);
        }}
      >
        ثبت آگهی
      </button>
    </div>
  );
};

export default WantedServiceMachineryForm;
